
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import "@/store/modules/forms/form20";
const form20State = namespace("Form20");

import Form20ProcessHeader from "@/components/process/Form20/components/Form20ProcessHeader.vue";
import Form20 from "@/components/process/Form20/components/pdf/Form20.vue"

import { form20StatusInfoType } from '@/types/Information/Form20';

@Component({
    components:{
        Form20ProcessHeader,
        Form20
    }
})
export default class PreviewForm20 extends Vue {

    @form20State.State
    public currentNoticeOfObjectionToWithdrawalId: string;

    stepsCompleted = {} as form20StatusInfoType; 
    
    dataReady = false;
    pdfReady = false;

    mounted() {
        this.dataReady = false;         
        this.stepsCompleted = {
            first: true,
            second: false,
            third: false
        }
        this.dataReady = true;       
    }

    public navigateToSubmitPage() {
        this.$router.push({name: "proceed-form20"}); 
    }
}
